import {
  Avatar,
  Badge,
  Box,
  Button,
  Dialog,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
  makeStyles,
} from "@material-ui/core";
import {
  Error,
  Loading,
  useAuthenticated,
  useDataProvider,
  useTranslate,
} from "react-admin";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import {
  converttoWgPhoneFormat,
  removeEmptyStringFieldfromObject,
} from "../../utils";
import { useEffect, useState } from "react";

import Autocomplete from "@material-ui/lab/Autocomplete";
import { Calendar } from "react-date-range";
import ConfirmationView from "./ConfirmationView";
import EditIcon from "../../assets/icons/edit.png";
import ErrorDialog from "../../components/ErrorDialog";
import FullAddressInput from "../../components/FullAddressInput";
import MemberRegisterQRDialog from "../../components/MemberRegisterQRDialog";
import NumberFormatInput from "../../components/NumberFormatInput";
import PermissionChecker from "../../components/PermissionChecker";
import SfBreadcrumbs from "../../components/SfBreadcrumbs";
import SimpleLayoutContainer from "../../components/SimpleLayoutContainer";
import SuccessView from "./SuccessView";
import moment from "moment";
import { removeEmptyFieldfromObject } from "../../utils";
import settings from "../../utils/settings";
import useAddressInfo from "../../hooks/useAddressInfo";
import useCheckPermission from "../../hooks/useCheckPermission";
import useMemberForm from "../../hooks/useMemberForm";
import useOccupations from "../../hooks/useOccupations";
import useSFAlert from "../../hooks/useSFAlert";

const useStyles = makeStyles((theme) => ({
  allContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    padding: 20,
    paddingLeft: 40,
    paddingRight: 40,
    boxSizing: "border-box",
  },
  header: {
    marginTop: -10,
  },
  titleSection: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  titleSection_rightZone: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "row",
  },
  titleSection_rightZone_dateCreated: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-end",
    flexDirection: "column",
  },
  fullname_gender_leftSection: {
    width: 680,
  },
  uploadImage_RightSection: {
    paddingLeft: 10,
    paddingRight: 10,
    boxSizing: "border-box",
    width: 200,
  },
  fullnameSection: {
    display: "flex",
    alignItems: "baseline",
    flexDirection: "column",
  },
  fullnameLanguageSpecificSection: {
    marginTop: 12,
    flexDirection: "row",
  },
  phoneEmailSection: {
    marginTop: 12,
    display: "flex",
    alignItems: "baseline",
    flexDirection: "row",
  },
  occupationNationSection: {
    marginTop: 12,
    display: "flex",
    alignItems: "baseline",
    flexDirection: "row",
  },
  addressRecommendSection: {
    marginTop: 12,
    display: "flex",
    alignItems: "baseline",
    flexDirection: "row",
  },
  proceedButtonContainer: {
    marginTop: 20,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  proceedButton: {
    width: 322,
    height: 57,
    fontSize: 28,
  },
  textFieldHeight: {
    height: theme.defaultTextFieldHeight,
  },
  subAddressContainer: {
    width: "100%",
    flexDirection: "row",
    display: "flex",

    justifyContent: "space-between",
  },
  uploadImage_paper: {
    width: "100%",
    height: "100%",
    paddingTop: 19,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  editIcon: {
    height: 27,
    width: 27,
  },
  avatar: {
    width: "114px",
    height: "114px",
    fontSize: 50,
    color: "orange",
    borderWidth: 10,
    backgroundColor: "white",
  },
  avatarBorder: {
    justifyContent: "center",
    display: "flex",
    width: "114px",
    height: "114px",
    alignItem: "center",
  },
  referContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  occupationRow: {
    marginTop: 12,
    display: "flex",
    flexDirection: "row",
  },
  selected: {
    backgroundColor: theme.orange + "!important",
  },
  required_textfield: {
    borderColor: "darkorange",
  },
}));

const initialRegisterData = {
  firstname: "",
  lastname: "",
  nickname: "",
  firstname_th: "",
  lastname_th: "",
  firstname_en: "",
  lastname_en: "",
  nickname_th: "",
  nickname_en: "",
  phone: "",
  email: "",
  gender: "",
  birthdate: "",
  occupation: "",
  nationality: "",
  state: "",
  address: "",
  subdistrict: "",
  district: "",
  province: "",
  postcode: "",
  locale: "th-TH",
  status: "Active",
  recommended_by: "Walk-in",
  invite_code: "",
};

const validationRules = {
  firstname: {
    required: true,
    rule: (firstname) => /^[a-zA-Z.ก-๛ ]+$/.test(String(firstname)),
    message: "ra.text.dontContainSpecialCharacter",
  },
  lastname: {
    required: true,
    rule: (lastname) => /^[a-zA-Z.ก-๛ ]+$/.test(String(lastname)),
    message: "ra.text.dontContainSpecialCharacter",
  },
  nickname: {
    required: false,
    rule: () => true,
  },
  firstname_th: { required: false, rule: () => true },
  lastname_th: { required: false, rule: () => true },
  firstname_en: {
    required: false,
    rule: (firstname_en) => /^[a-zA-Z. ]+$/.test(String(firstname_en)),
    message: "Firstname  should be English",
  },
  lastname_en: {
    required: false,
    rule: (lastname_en) => /^[a-zA-Z. ]+$/.test(String(lastname_en)),
    message: "Lastname  should be English",
  },
  nickname_th: { required: false, rule: () => true },
  nickname_en: { required: false, rule: () => true },
  phone: {
    required: true,
    rule: (phone) => phone.length === 10,
    message: "ra.text.phoneNotValid",
  },
  email: {
    rule: (email) =>
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        String(email).toLowerCase()
      ),
    message: "ra.text.emailNotValid",
  },
  birthdate: {
    rule: (bday) => {
      try {
        if (bday.length < 1) {
          return false;
        }
        new Date(bday);
        return true;
      } catch (error) {
        return false;
      }
    },
    message: "ra.text.birthdateNotValid",
  },
  gender: {
    required: true,
    rule: () => true,
    message: "ra.text.genderRequired",
  },
  occupation: { rule: () => true },
  nationality: { rule: () => true },
  state: { rule: () => true },
  address: { rule: () => true },
  subdistrict: { rule: () => true },
  district: { rule: () => true },
  province: { rule: () => true },
  postcode: { rule: () => true },
  locale: { rule: () => true },
  image: { rule: () => true },
  status: { rule: () => true },
  recommended_by: { rule: () => true },
  invite_code: { rule: () => true },
};

const textFieldValidate = (validator, key) => {
  return {
    error: validator && validator[key],
    helperText: validator && validator[key] ? validator[key] : null,
  };
};

const Register = () => {
  useAuthenticated();
  const [showQR, setShowQR] = useState(false);
  const { occupations, loading, error } = useOccupations();
  const { loading: addressLoading, error: addressError } = useAddressInfo();
  const classes = useStyles();
  const [alert] = useSFAlert();
  const [registerData, setRegisterData] = useState(initialRegisterData);
  const [validateError, setValidateError] = useState();
  const dataProvider = useDataProvider();
  const [image, setImage] = useState("");
  const [step, setStep] = useState({ step: 0, data: null }); //step=0 form 1 confirm/error 3 complete
  const { form, loading: formLoading, error: formError } = useMemberForm();
  let [showError, setShowError] = useState({ error: false, message: "" });
  const [openCalendar, setOpenCalendar] = useState(false);
  const { checkWritePermission } = useCheckPermission();
  const [allowNewUser, setAllowNewUser] = useState(false);
  const translate = useTranslate();
  async function checkData() {
    const allowNewUser = await checkWritePermission(
      "Page.Merchant.Payment.Subscribe"
    );
    setAllowNewUser(allowNewUser);
  }
  useEffect(() => {
    checkData();
    return;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const onChangeHandler = (value, key) => {
    if (key === "province") {
      setRegisterData({
        ...registerData,
        province: value,
        district: "",
        subdistrict: "",
        postcode: "",
      });
    } else if (key === "district") {
      setRegisterData({
        ...registerData,
        district: value,
        subdistrict: "",
        postcode: "",
      });
    } else if (key === "subdistrict") {
      setRegisterData({
        ...registerData,
        subdistrict: value,
        postcode: "",
      });
    } else setRegisterData({ ...registerData, [key]: value });

    //make error message disapear
    let tempValidateError = { ...validateError };
    delete tempValidateError[key];
    setValidateError({ ...tempValidateError });
  };

  const onCompleteHandler = () => {
    try {
      const validateResult = Object.entries(registerData).reduce(
        (total, [key, value]) => {
          if (validationRules[key].required && (!value || value === "")) {
            return { ...total, [key]: translate("ra.text.fieldRequired") };
          } else if (!value || value === "") {
            return total;
          } else {
            if (!validationRules[key].rule(value)) {
              return {
                ...total,
                [key]: translate(validationRules[key].message),
              };
            } else return total;
          }
        },
        {}
      );

      if (Object.keys(validateResult).length > 0) {
        setValidateError(validateResult);
      } else setStep({ step: 1, data: null });
    } catch (error) {
      alert("Error");
    }
  };

  const onChangeSelectImageHandler = (file) => {
    //Simple Validate image
    if (file.size > 10000000) {
      return;
    }

    setRegisterData({
      ...registerData,
      image: {
        rawFile: file,
        src: URL.createObjectURL(file),
        title: "profile",
      },
    });
    setImage(URL.createObjectURL(file));

    //{"rawFile":{"path":"download (1).png"},"src":"blob:http://localhost:3000/3b381ad1-7a70-4c28-9773-88af0834607c","title":"download (1).png"}}
  };
  const { branchId } = settings();

  if (loading || addressLoading || formLoading) return <Loading></Loading>;
  if (error || addressError || formError) return <Error />;

  const genderList = form.fields.find((field) => field.id === "gender").values;
  const marriageStatusList = form.fields.find(
    (field) => field.id === "state"
  ).values;
  const recommendList = form.fields.find(
    (field) => field.id === "recommended_by"
  ).values;

  return (
    <SimpleLayoutContainer>
      <Box className={classes.allContainer}>
        <SfBreadcrumbs path="/register" noMarginTop noMarginLeft />
        {step.step === 0 ? (
          <>
            <Typography variant="h6" align="center" className={classes.header}>
              {translate("ra.text.inputInformation.customerInformation")}
            </Typography>
            <form noValidate autoComplete="off">
              <Box className={classes.titleSection}>
                <Typography variant="subtitle2">
                  {translate("ra.text.inputInformation.customerInformation")}
                </Typography>
                <Box className={classes.titleSection_rightZone}>
                  <Box>
                    <Button
                      variant="contained"
                      color="primary"
                      disabled={!branchId}
                      onClick={() => setShowQR(true)}
                    >
                      QR
                    </Button>
                  </Box>
                </Box>
              </Box>

              <Typography variant="body2">
                {translate("ra.text.inputInformation.fullName")} *
              </Typography>
              <Box style={{ display: "flex", flexDirection: "row" }}>
                <Box className={classes.fullname_gender_leftSection}>
                  <Box className={classes.fullnameSection}>
                    <Box className={classes.fullnameLanguageSpecificSection}>
                      <TextField
                        required
                        variant="outlined"
                        placeholder={translate(
                          "ra.text.inputInformation.firstname"
                        )}
                        value={registerData.firstname}
                        {...textFieldValidate(validateError, "firstname")}
                        onChange={(e) =>
                          onChangeHandler(e.target.value, "firstname")
                        }
                        style={{
                          width: 231,
                        }}
                        InputProps={{
                          classes: {
                            root: classes.required_textfield,
                          },
                        }}
                      />
                      <TextField
                        required
                        variant="outlined"
                        placeholder={translate(
                          "ra.text.inputInformation.lastname"
                        )}
                        value={registerData.lastname}
                        {...textFieldValidate(validateError, "lastname")}
                        onChange={(e) =>
                          onChangeHandler(e.target.value, "lastname")
                        }
                        style={{
                          width: 231,
                          marginLeft: 8,
                        }}
                        InputProps={{
                          classes: {
                            root: classes.required_textfield,
                          },
                        }}
                      />
                      <TextField
                        required
                        variant="outlined"
                        placeholder={translate(
                          "ra.text.inputInformation.nickname"
                        )}
                        value={registerData.nickname}
                        {...textFieldValidate(validateError, "nickname")}
                        onChange={(e) =>
                          onChangeHandler(e.target.value, "nickname")
                        }
                        style={{ width: 198, marginLeft: 8 }}
                      />
                    </Box>
                  </Box>
                  <Box className={classes.phoneEmailSection}>
                    <Box style={{ flexGrow: 3 }}>
                      <Typography variant="body2">
                        {translate("ra.text.inputInformation.phoneNumber")} *
                      </Typography>
                      <NumberFormatInput
                        required
                        type="tel"
                        format="###-###-####"
                        placeholder={translate(
                          "ra.text.inputInformation.phoneNumber"
                        )}
                        {...textFieldValidate(validateError, "phone")}
                        value={registerData.phone}
                        onValueChange={({ formattedValue, value }) =>
                          onChangeHandler(value, "phone")
                        }
                        style={{ width: "100%" }}
                        InputProps={{
                          classes: {
                            root: classes.required_textfield,
                          },
                        }}
                      />
                    </Box>
                    <Box style={{ flexGrow: 3, marginLeft: 23 }}>
                      <Typography variant="body2">
                        {" "}
                        {translate("ra.text.inputInformation.emailAddress")}
                      </Typography>
                      <TextField
                        {...textFieldValidate(validateError, "email")}
                        variant="outlined"
                        placeholder={translate(
                          "ra.text.inputInformation.emailAddress"
                        )}
                        value={registerData.email}
                        onChange={(e) =>
                          onChangeHandler(e.target.value, "email")
                        }
                        type="email"
                        style={{ width: "100%" }}
                      />
                    </Box>
                    <Box style={{ flexGrow: 1, marginLeft: 23 }}>
                      <Typography variant="body2">
                        {translate("ra.text.inputInformation.birthday")}
                      </Typography>
                      <TextField
                        style={{ width: "100%" }}
                        onClick={() => setOpenCalendar(true)}
                        value={registerData.birthdate}
                        variant="outlined"
                      />
                      {/* <NumberFormatInput
                        variant="outlined"
                        format="##-##-####"
                        {...textFieldValidate(validateError, "birthdate")}
                        value={registerData.birthdate}
                        placeholder="dd-mm-yyyy"
                        onValueChange={({ formattedValue, value }) =>
                          onChangeHandler(formattedValue, "birthdate")
                        }
                        style={{ width: "100%" }}
                      /> */}
                    </Box>
                  </Box>
                </Box>
                <Box className={classes.uploadImage_RightSection}>
                  <Paper className={classes.uploadImage_paper}>
                    <Box
                      borderColor="orange"
                      border={5}
                      borderRadius="50%"
                      className={classes.avatarBorder}
                    >
                      <input
                        accept="image/*"
                        id="contained-button-file"
                        type="file"
                        style={{ display: "none" }}
                        onChange={(e) =>
                          onChangeSelectImageHandler(e.target.files[0])
                        }
                      />
                      <label htmlFor="contained-button-file">
                        <Badge
                          overlap="circle"
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                          }}
                          badgeContent={
                            <Avatar
                              alt="edit"
                              src={EditIcon}
                              className={classes.editIcon}
                            />
                          }
                        >
                          <Avatar
                            src={image}
                            alt="?"
                            className={classes.avatar}
                          />
                        </Badge>
                      </label>
                    </Box>
                  </Paper>
                </Box>
              </Box>
              <Box className={classes.occupationNationSection}>
                <Box style={{ flexGrow: 1 }}>
                  <Typography variant="body2">
                    {translate("ra.text.inputInformation.gender")} *
                  </Typography>

                  <ToggleButtonGroup
                    value={registerData.gender}
                    exclusive
                    onChange={(_, currentSelection) => {
                      if (currentSelection === null) return;
                      onChangeHandler(currentSelection, "gender");
                    }}
                  >
                    {genderList.map((g) => (
                      <ToggleButton
                        classes={{ selected: classes.selected }}
                        value={g.code}
                      >
                        {g.name}
                      </ToggleButton>
                    ))}
                  </ToggleButtonGroup>
                  {textFieldValidate(validateError, "gender").helperText ? (
                    <>
                      <br />
                      <Typography variant="caption" style={{ color: "red" }}>
                        {textFieldValidate(validateError, "gender").helperText}
                      </Typography>
                    </>
                  ) : null}
                </Box>

                <Box style={{ flexGrow: 3, marginLeft: 23 }}>
                  <Typography variant="body2">
                    {translate("ra.text.inputInformation.nationality")}
                  </Typography>
                  <Box style={{ display: "flex" }}>
                    <ToggleButton
                      value="check"
                      selected={registerData.nationality === "Thai"}
                      onClick={() => {
                        onChangeHandler("Thai", "nationality");
                      }}
                      classes={{ selected: classes.selected }}
                    >
                      Thai
                    </ToggleButton>
                    <TextField
                      variant="outlined"
                      placeholder="Other"
                      style={{ marginLeft: 8 }}
                      onChange={(e) =>
                        onChangeHandler(e.target.value, "nationality")
                      }
                      value={
                        registerData.nationality !== "Thai"
                          ? registerData.nationality
                          : ""
                      }
                    />
                  </Box>
                </Box>
                <Box style={{ flexGrow: 3, marginLeft: 23 }}>
                  <Typography variant="body2">
                    {translate("ra.text.inputInformation.martialStatus")}
                  </Typography>
                  <Box style={{ display: "flex" }}>
                    <ToggleButtonGroup
                      value={registerData.state}
                      exclusive
                      onChange={(_, currentSelection) =>
                        //setMarriageStatus(currentSelection);
                        onChangeHandler(currentSelection, "state")
                      }
                    >
                      {marriageStatusList.map((m) => (
                        <ToggleButton
                          classes={{ selected: classes.selected }}
                          value={m.code}
                        >
                          {m.name}
                        </ToggleButton>
                      ))}
                    </ToggleButtonGroup>
                    <TextField
                      value={
                        registerData.state !== "single" &&
                        registerData.state !== "married"
                          ? registerData.state
                          : ""
                      }
                      placeholder="Other"
                      style={{ marginLeft: 8 }}
                      variant="outlined"
                      onChange={(e) => onChangeHandler(e.target.value, "state")}
                    />
                  </Box>
                </Box>
              </Box>
              <Box className={classes.addressRecommendSection}>
                <Box></Box>
                <Box>
                  <Typography variant="body2">
                    {translate("ra.text.inputInformation.address")}
                  </Typography>
                  <Box className={classes.subAddressContainer}>
                    <TextField
                      style={{
                        width: 300,
                      }}
                      placeholder={translate(
                        "ra.text.inputInformation.addressHint"
                      )}
                      onChange={(e) =>
                        onChangeHandler(e.target.value, "address")
                      }
                      variant="outlined"
                      value={registerData.address}
                    />
                    <FullAddressInput onChangeHandler={onChangeHandler} />
                  </Box>
                </Box>
              </Box>
              <Box className={classes.occupationRow}>
                <Box style={{ flexGrow: 1 }}>
                  <Typography variant="body2">
                    {translate("ra.text.inputInformation.occupation")}
                  </Typography>
                  <Autocomplete
                    options={occupations}
                    value={registerData.occupation}
                    getOptionLabel={(option) => option.name}
                    onChange={(_, newValue) => {
                      onChangeHandler(newValue, "occupation");
                    }}
                    style={{ width: 231 }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Occupation"
                        variant="outlined"
                      />
                    )}
                  />
                </Box>
                <Box style={{ flexGrow: 1, marginLeft: 23 }}>
                  <Typography variant="body2">
                    {translate("ra.text.ci.generalInformation.recommendBy")}
                  </Typography>
                  <Box className={classes.referContainer}>
                    <Select
                      value={registerData.recommended_by}
                      onChange={(e) =>
                        onChangeHandler(e.target.value, "recommended_by")
                      }
                      variant="outlined"
                      style={{ width: 142 }}
                    >
                      {recommendList.map((rec) => (
                        <MenuItem value={rec.code}>{rec.name}</MenuItem>
                      ))}
                    </Select>
                    <TextField
                      disabled={registerData.recommended_by === "Walk-in"}
                      placeholder="Refer friend 1"
                      variant="outlined"
                      value={registerData.invite_code}
                      style={{ width: 231 }}
                      onChange={(e) => {
                        return onChangeHandler(e.target.value, "invite_code");
                      }}
                    />
                  </Box>
                </Box>
              </Box>
              <Box className={classes.proceedButtonContainer}>
                {!branchId && (
                  <Typography variant="caption" style={{ color: "red" }}>
                    Can't register in branch All
                  </Typography>
                )}
                <Button
                  variant="contained"
                  className={classes.proceedButton}
                  color="primary"
                  disabled={!allowNewUser || !branchId}
                  onClick={() => onCompleteHandler()}
                >
                  {translate("ra.text.proceed")}
                </Button>
              </Box>
            </form>
          </>
        ) : step.step === 1 ? (
          <ConfirmationView
            registerData={{
              ...registerData,
              occupation: registerData.occupation
                ? registerData.occupation.name
                : null,
              address: `${registerData.address} 
            ${registerData.subdistrict ? registerData.subdistrict.name : ""} 
            ${registerData.district ? registerData.district.name : ""} 
            ${registerData.province ? registerData.province.name : ""} 
            ${registerData.postcode ? registerData.postcode.code : ""}`,
            }}
            onClickEdit={() => setStep({ step: 0 })}
            onConfirm={() => {
              const cleanRegisterData = {
                ...registerData,
                firstname: registerData?.firstname,
                lastname: registerData?.lastname,
                nickname: registerData?.nickname,

                phone: converttoWgPhoneFormat(registerData.phone),
                birthdate: registerData.birthdate
                  ? registerData.birthdate.split("-").reverse().join("-")
                  : null,
                occupation_id: registerData.occupation
                  ? registerData.occupation.id
                  : "",
                district_id: registerData.district
                  ? registerData.district.id
                  : "",
                sub_district_id: registerData.subdistrict
                  ? registerData.subdistrict.id
                  : "",
                province_id: registerData.province
                  ? registerData.province.id
                  : "",
                postcode_id: registerData.postcode
                  ? registerData.postcode.id
                  : "",
                invite_codes:
                  registerData.invite_code && registerData.invite_code !== null
                    ? new Array(registerData.invite_code)
                    : "",
                postcode: "",
                district: "",
                occupation: "",
                subdistrict: "",
                province: "",
              };

              const removedEmptyField =
                removeEmptyFieldfromObject(cleanRegisterData);
              const removedBlankField =
                removeEmptyStringFieldfromObject(removedEmptyField);

              dataProvider
                .create("members", { data: { i18n: {}, ...removedBlankField } })
                .then((res) => {
                  return setStep({ step: 2, id: res.data.id });
                })
                .catch((error) => {
                  try {
                    const errorJson = JSON.parse(error);
                    if (errorJson.wgCode === "E07001") {
                      alert("บัญชีนี้ได้ถูกสมัครสมาชิกเรียบร้อยแล้วค่ะ");
                    } else if (errorJson.wgCode === "E02001") {
                      alert("เบอร์โทรศัพท์ไม่ถูกต้อง");
                    } else alert("Something went wrong: " + error);
                  } catch (e) {
                    alert("Something went wrong " + error);
                  }
                });
            }}
          />
        ) : (
          <SuccessView customerId={step.id} />
        )}

        <ErrorDialog
          open={showError.error}
          onClose={() => {
            setShowError({ error: false, message: "" });
          }}
          errorTitle={"Error!!"}
          errorMessage={showError.message}
          code={showError.code}
        />
      </Box>
      <MemberRegisterQRDialog open={showQR} onClose={() => setShowQR(false)} />
      <Dialog
        local="th"
        open={openCalendar}
        aria-labelledby="f-dialog-title"
        aria-describedby="f-dialog-description"
      >
        <Calendar
          date={
            registerData.birthdate
              ? new Date(moment(registerData.birthdate, "DD-MM-YYYY"))
              : new Date()
          }
          maxDate={new Date()}
          onChange={(date) => {
            onChangeHandler(moment(date).format("DD-MM-YYYY"), "birthdate");
            return setOpenCalendar(false);
          }}
          placeholder="dd-mm-yyyy"
          onValueChange={({ formattedValue, value }) =>
            onChangeHandler(formattedValue, "birthdate")
          }
        />
        {/* <Grid container className={classes.GridContainer}>
          <Button
            onClick={() => {
              setOpenCalendar(false);
            }}
            className={classes.ButtonNameCancle}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              //   handleClickFilter("Custom Date");
            }}
            className={classes.ButtonNameDone}
          >
            Done
          </Button>
        </Grid> */}
      </Dialog>
      <PermissionChecker code="Page.Merchant.Payment.Subscribe" />
    </SimpleLayoutContainer>
  );
};

export default Register;
